<ng-container *ngIf="noticia">
    <h2 *ngIf="showTitle">{{ noticia.titulo }}</h2>
    <div [innerHTML]="noticia.noticia | trustedhtml"></div>
</ng-container>
